/* tslint:disable */
/* eslint-disable */
import React, { useState } from 'react';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import { CreditCard, Payment } from '@material-ui/icons';
import { ConsoleActionButton } from '../../common/ConsoleActionButton';
import { useCommonStyles } from './AdminConsoleBilling';
import { useCampfireTheme } from '../../../../../theme/useCampfireTheme';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';

type Props = {
  card: any | null;
  shouldAlert?: boolean;
};

export const BillingMethod = (props: Props) => {
  const classes = useCommonStyles();
  const { theme } = useCampfireTheme();
  const { card, shouldAlert = false } = props;
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = useApiUrl();
  const customerPortalFetch = useCampfireFetch<{ url: string }>({ defer: true });

  const hasPaymentMethod = card?.card?.last4;

  const getCardIcon = () => {
    if (!hasPaymentMethod) return <Payment style={{ fontSize: '20px' }} />;
    const brand = card?.card?.brand?.toLowerCase();
    return <CreditCard style={{ fontSize: '20px' }} />;
  };

  const handleManageDetails = async () => {
    setIsLoading(true);
    try {
      const response = await customerPortalFetch.run({
        url: `${apiUrl}/tm/subscriptions/customer-portal`,
        method: 'POST',
        data: {
          returnUrl: window.location.href,
        },
      });

      if (response?.data?.data?.url) {
        window.location.href = response.data.data.url;
      }
    } catch (error) {
      console.error('Failed to open customer portal:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <Typography className={classes.sectionHeading}>Billing Method</Typography>
      <Box mt={2}>
        <Box display='flex' alignItems='center' mb={3}>
          <Box
            mr={2}
            display='flex'
            alignItems='center'
            justifyContent='center'
            style={{ color: theme.color.grey.neutralBrand500 }}
          >
            {getCardIcon()}
          </Box>
          <Box>
            <Typography
              style={{
                fontWeight: 600,
                fontSize: '16px',
                color: hasPaymentMethod ? '#333' : shouldAlert ? '#d32f2f' : '#333',
              }}
            >
              {hasPaymentMethod ? `•••• ${card.card.last4}` : 'No payment method'}
            </Typography>
            {hasPaymentMethod && (
              <Typography style={{ fontSize: '14px', color: '#666', textTransform: 'capitalize' }}>
                {card?.card?.brand}{' '}
                {card?.card?.exp_month &&
                  card?.card?.exp_year &&
                  `• Expires ${card.card.exp_month}/${card.card.exp_year}`}
              </Typography>
            )}
          </Box>
        </Box>

        <ConsoleActionButton
          variant='contained'
          onClick={handleManageDetails}
          disabled={isLoading}
          style={{
            backgroundColor: !hasPaymentMethod && shouldAlert ? '#d32f2f' : theme.color.secondary.main900,
            color: '#ffffff',
            boxSizing: 'border-box',
            borderRadius: '4px',
            textTransform: 'none',
            padding: '8px 16px',
            fontWeight: 500,
            fontSize: '14px',
          }}
        >
          {isLoading ? (
            <CircularProgress size={16} color='inherit' />
          ) : hasPaymentMethod ? (
            'Manage Details'
          ) : (
            'Add Payment Method'
          )}
        </ConsoleActionButton>
      </Box>
    </Box>
  );
};
